import React, { useMemo } from "react";
import HeatPanel from "./HeatPanel";
import { buildHeatGrid } from "./beautyStatsMetrics";
import { weekdayLong, weekdayPlural } from "./statsHeat";
import { fmtNumber1, fmtPct0 } from "./statsFormat";

/**
 * Horarios tab of the Beauty statistics: weekday x hour heatmap of the professionals' agenda. Each
 * cell is booked / agenda time of that weekday and hour, averaged over the period (a darker cell is
 * a busier slot). Only the hours where someone works are drawn, derived from the data; hours where
 * nobody works, or the agenda is blocked, are hatched instead of drawn as 0 %. The tooltip tells
 * how many professionals were busy out of how many worked, on average.
 *
 * @param {{current: object}} props  `current` is a stats response.
 */
export default function BeautyHorariosTab({ current }) {
  const grid = useMemo(() => buildHeatGrid(current), [current]);

  const openTip = (row, cell) => {
    const day = cell.days === 1 ? weekdayLong(row.weekday) : weekdayPlural(row.weekday);
    return [
      { value: fmtPct0(cell.value), label: "de la agenda ocupada" },
      {
        value: `${fmtNumber1(cell.busyCourts)} de ${fmtNumber1(cell.openCourts)}`,
        label: `profesionales con turno, promedio de ${cell.days} ${day}`,
      },
    ];
  };

  return (
    <HeatPanel
      grid={grid}
      title="Ocupación de agenda por día y horario"
      subtitle="Promedio del período, sobre las horas en que trabaja cada profesional."
      ariaLabel="Mapa de ocupación de agenda por día de la semana y hora. El detalle está en la vista de tabla."
      closedLabel="Nadie trabaja o bloqueado"
      closedTip="Nadie trabaja o está bloqueado"
      openTip={openTip}
    />
  );
}
